import { css } from '@/styled-system/css';

// Main container for the key-value pair using flexbox space-between layout
// Renders as <dl> per HP-7690 — zero-out default margins so it lays out flat.
export const keyValueContainer = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 'default', // Ensure minimum 16px gap between label/value
  minWidth: 0, // Allow content to shrink when necessary

  margin: 0,
});

// Styling for the key/label (left side)
export const keyValueLabel = css({
  color: 'text.subtle', // User requirement - grey color for labels
  fontSize: '400', // 16px - User requirement
  fontWeight: '400', // Regular weight - User requirement

  flexGrow: 0,

  flexShrink: 0,
  flexBasis: 'auto',
  textAlign: 'left', // Ensure left alignment
});

// Styling for the value (right side) — renders as <dd>; reset default margin.
export const keyValueValue = css({
  color: 'text.neutral', // User requirement - blue color for values
  fontSize: '400', // 16px - User requirement
  fontWeight: '700', // Bold weight - User requirement

  flexGrow: 0,

  flexShrink: 0,
  flexBasis: 'auto',
  textAlign: 'right', // Ensure right alignment
  wordWrap: 'break-word', // Handle long values gracefully
  overflowWrap: 'break-word', // Modern alternative for better browser support
  margin: 0, // <dd> default has margin-inline-start; flatten for two-column layout
});
